export const userProfilePageContent = {
    en: {

        s: "Who am I?",
        h1: "Manage your personal settings and the data you share with us.",
        txt1: "Here you can change various types of your personal data, the notifications you receive from us, and how you receive them.",
        txt2: "Important: All fields marked with an asterisk are required. To ensure everything works properly, please do not leave these fields empty.",
        join: "Joined on",
        name: "Name:*",
        ageG: "Age group:*",
        country: "Country:*",
        telNum: "Telephone number:",
        email: "Email*",
        timeZ: "Time-zone:*",
        prefLang: "Preferred Language:*",
        cancel: "Cancel",
        editData: "Edit Data",
        required: "fields are required",

        costumPlan: "Connect costum plan from your physiotherapist",

        currExePlan: "Current exercise plan:",
        startDate: "Starting date:",
        discExe: "Discovered exercises:",
        complSess: "Completed sessions:",
        totalExeDone: "Total Exercises Done:",
        totalSessDone: "Total Sessions Done:",
        exeDone: "Exercises done:",
        streak: "Day streak:",
        yourStats: "Your statistics",
        planNum: "Plans started:",
        
        subPlan: "Subscription plan:",
        nextPayDay: "Next payment date:",
        validTill: "Valid until:",
        payCardCode: "Payment card code:",
        cardOwner: "Card owner:",
        manageSub: "Manage Subscription",
        updatePayment: "Update Payment",

        emailNoti: "Email Notifications:",
        whatNoti: "WhatsApp Notifications:",
        exeReminders: "Exercise reminders:",
        sessionReminders: "Session reminders:",
        productUpdates: "Product updates:",
        subReminders: "Subscription Reminders:",
        submit_btn: "Submit",

        webNoti:"Website Notifications:",
        save: "Save",
        save2: "Saving...",
        connect: "Connect",
        connecting: "Connecting...",

    },
    sl: {

    s:"Kdo sem jaz?",
    h1:"Spreminjajte vaše osebne nastavitve in podatke, ki nam jih posredujete.",
    txt1: "Tukaj lahko spremenite vrsto različnih vaših osebnih podatkov, obvestil ki jih prejemate z naše strani in kako jih pridobivate.",
    txt2: "Pomembno: Vsa polja ki so uznačena z zvezdico so obvezna, če želite da vse deluje brezhibno prosim ne puščajte teh polj praznih. ",
   
        join: "Uporabnik od",
        name: "Ime:*",
        ageG: "Starostna skupina:*",
        country: "Država:*",
        telNum: "Telefonska številka:",
        email: "E-pošta*",
        timeZ: "Časovni pas:*",
        prefLang: "Primarni jezik:*",
        cancel: "Prekliči",
        editData: "Uredi podatke",
        required: "polja so obvezna",

        costumPlan: "Poveži prilagojen plan od svojega fizioterapevta.",
        currExePlan: "Trenutni vadbeni načrt:",
        startDate: "Začetni dan:",
        discExe: "Odkrite vaje:",
        complSess: "Zaključene vadbe:",
        totalExeDone: "Števio opravljenih vaj:",
        totalSessDone: "Število opravljenih vadb:",
        exeDone: "Števio opravljenih vaj:",
        yourStats: "Statistika:",
        planNum: "Število planov:",
        streak: "Dnevni niz:",
        subPlan: "Naročniški načrt:",
        nextPayDay: "Naslednji datum plačila:",
        validTill: "Velajvno do:",
        payCardCode: "Koda plačilne kartice:",
        cardOwner: "Lastnik kartice:",
        manageSub: "Upravljaj naročnino",
        updatePayment: "Posodobi plačilo",

        emailNoti: "Obvestila preko spletne pošte:",
        whatNoti: "Obvestila preko WhatsApp-a:",
        exeReminders: "Opomniki za vaje:",
        sessionReminders: "Opomniki za vadbe:",
        productUpdates: "Posodobitve izdelka:",
        subReminders: "Opomniki o naročnini",
        submit_btn: "Shrani",
        webNoti: "Obvestila preko spletne strani:",
        save: "Shrani",
        save2: "Shranjevanje..",
        connect: "Poveži me",
        connecting: "Povezovanje...",

    },
} as const;
